import { Color } from "../defines/colors"
import { ItemType } from "../defines/enums"

class PlayerHint {
  private _year?: number
  private _month?: number
  private _dayOfMonth?: number

  constructor(
    public type: ItemType,
    public contents: string,
    year?: number,
    month?: number,
    dayOfMonth?: number
  ) {
    if (year === undefined) {
      const date = new Date()
      this._year = date.getUTCFullYear()
      this._month = date.getUTCMonth() + 1
      this._dayOfMonth = date.getUTCDate() % 100
    } else {
      this._year = year > 100 ? year % 100 : year
      if (month) {
        this._month = month
      }
      if (dayOfMonth) {
        this._dayOfMonth = dayOfMonth
      }
    }
  }

  public get year(): number | undefined {
    return this._year
  }

  public get month(): number | undefined {
    return this._month
  }

  public get dayOfMonth(): number | undefined {
    return this._dayOfMonth
  }

  toString(bg: string): string {
    const date: string = this._month + "/" + this._dayOfMonth + "/" + this._year
    return (
      `%c{${Color.HINT_CONTENTS}}%b{${bg}}${this.contents} [found ` +
      `%c{${Color.HINT_DATE}}%b{${bg}}${date}` +
      `%c{#fff}%b{${bg}}]`
    )
  }
}

export { PlayerHint }
